class ProfileAction {

  static SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE'

  static setProfileImage = (image: string) => ({
    type: ProfileAction.SET_PROFILE_IMAGE,
    payload: {
      image
    }
  })


  static SET_USERNAME = 'SET_USERNAME'

  static setUsername = (username: string) => ({
    type: ProfileAction.SET_USERNAME,
    payload: {
      username
    }
  })
}

export default ProfileAction